import { AppDispatch } from "../../store/store";
import { setCompany, setUser } from "../../store/slices/auth";
import {
  setUserProfile,
  setUserProfileError,
  setUserProfileLoading,
} from "../../store/slices/user-profile";
import axiosInstance from "../../utils/axiosInstance";
import { IApiResponse } from "../../store/@types/api-response";
import { ILoginUser } from "../../store/@types/auth";
import { ICompany } from "../../store/@types/user";
// import { notify } from "../../components/alerts";
import { getErrorMessage } from "./apiError";

type IUserProfileResponse = ILoginUser & {
  company_status?: ICompany | string;
};

export const get_user_profile = async (dispatch: AppDispatch) => {
  dispatch(setUserProfileLoading(true));
  dispatch(setUserProfileError(null));
  dispatch(setUserProfile(null));

  try {
    const response = await axiosInstance.get<
      IApiResponse<IUserProfileResponse>
    >("/api/v1/client/profile");

    if (!response.data.success) {
      const message = response.data.message || "Unable to load your profile.";
      dispatch(setUserProfileError(message));
      return;
    }

    const { company_status, ...profile } = response.data.data;
    dispatch(setUserProfile(profile));
    dispatch(setUser(profile));

    if (company_status !== undefined) {
      dispatch(setCompany(company_status));
    }
  } catch (error) {
    const message = getErrorMessage(error, "Unable to load your profile.");
    dispatch(setUserProfileError(message));
    console.error("Error fetching user profile:", error);
  } finally {
    dispatch(setUserProfileLoading(false));
  }
};
